var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _rect4, _line, _line2, _line3, _line4, _line5, _line6, _line7, _g, _line8, _line9, _line0, _line1, _line10, _line11, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGold(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 103,
    r: 80,
    fill: "#00FFFF",
    opacity: 0.45
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 97,
    r: 80,
    fill: "#FF00FF",
    opacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 60 Q58 100 70 118 Q84 138 100 140 Q116 138 130 118 Q142 100 138 60 Z",
    fill: "white",
    stroke: "#FF00FF",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65 62 Q61 102 73 120 Q87 140 103 142 Q119 140 133 120 Q145 102 141 62 Z",
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62 72 Q38 72 36 90 Q34 108 62 105",
    fill: "none",
    stroke: "#FF00FF",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65 74 Q41 74 39 92 Q37 110 65 107",
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M138 72 Q156 74 158 90 Q160 106 138 105",
    fill: "none",
    stroke: "#FF00FF",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M141 74 Q159 76 161 92 Q163 108 141 107",
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 140,
    width: 14,
    height: 18,
    fill: "white",
    stroke: "#FF00FF",
    strokeWidth: 2.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 142,
    width: 14,
    height: 18,
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 157,
    width: 60,
    height: 12,
    rx: 3,
    fill: "white",
    stroke: "#FF00FF",
    strokeWidth: 2.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 159,
    width: 60,
    height: 12,
    rx: 3,
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 75,
    x2: 80,
    y2: 110,
    stroke: "#FFD700",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    opacity: 0.8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 93,
    y1: 68,
    x2: 91,
    y2: 115,
    stroke: "#FFD700",
    strokeWidth: 3,
    strokeLinecap: "round",
    opacity: 0.9
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 104,
    y1: 66,
    x2: 104,
    y2: 116,
    stroke: "#FFD700",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 115,
    y1: 68,
    x2: 117,
    y2: 115,
    stroke: "#FFD700",
    strokeWidth: 3,
    strokeLinecap: "round",
    opacity: 0.9
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 123,
    y1: 76,
    x2: 124,
    y2: 108,
    stroke: "#FFD700",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.7
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 85,
    y1: 77,
    x2: 83,
    y2: 112,
    stroke: "#00CCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 107,
    y1: 68,
    x2: 107,
    y2: 118,
    stroke: "#00CCCC",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-8 100 46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 28 L104 40 L116 40 L107 48 L110 60 L100 53 L90 60 L93 48 L84 40 L96 40 Z",
    fill: "white",
    stroke: "#FF00FF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 30 L107 42 L119 42 L110 50 L113 62 L103 55 L93 62 L96 50 L87 42 L99 42 Z",
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 28 L104 40 L116 40 L107 48 L110 60 L100 53 L90 60 L93 48 L84 40 L96 40 Z",
    fill: "#FFD700",
    opacity: 0.6
  }))), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 38,
    y1: 48,
    x2: 48,
    y2: 48,
    stroke: "#FFD700",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.8
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 43,
    y1: 43,
    x2: 43,
    y2: 53,
    stroke: "#FFD700",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.8
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 152,
    y1: 44,
    x2: 162,
    y2: 44,
    stroke: "#FFD700",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.7
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 157,
    y1: 39,
    x2: 157,
    y2: 49,
    stroke: "#FFD700",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.7
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 140,
    x2: 48,
    y2: 140,
    stroke: "#00FFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.6
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 136,
    x2: 44,
    y2: 144,
    stroke: "#00FFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.6
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 193,
    fontFamily: "'Courier New', monospace",
    fontSize: 13,
    fill: "#FFD700",
    textAnchor: "middle",
    fontWeight: "bold",
    letterSpacing: 3
  }, "GOLD")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 102,
    y: 195,
    fontFamily: "'Courier New', monospace",
    fontSize: 13,
    fill: "#00CCCC",
    textAnchor: "middle",
    fontWeight: "bold",
    letterSpacing: 3,
    opacity: 0.45
  }, "GOLD")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/gold.444aeb73c197c19edc8218829088c492.svg";
export { ForwardRef as ReactComponent };